<div class="st-dialog-header">
  <span class="st-dialog-icon is-danger" aria-hidden="true"><i class="bi bi-person-dash"></i></span>
  <div class="st-dialog-heading">
    <h5 class="st-dialog-title">Remove manager?</h5>
    <p class="st-dialog-subtitle">{{ employee.name }} will report to Admin and move to Unassigned.</p>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="st-dialog-body">
  <div class="st-person-card">
    <span class="st-avatar" [ngClass]="levelClass" aria-hidden="true">{{ initials }}</span>
    <div class="st-person-main">
      <div class="st-person-name">{{ employee.name }}</div>
      <div class="st-person-meta">
        <span class="badge app-badge" [ngClass]="badgeClass">{{ employee.designation }}</span>
        <span>#{{ employee.employee_number }}</span>
      </div>
      <div class="st-route">
        <span class="st-route-label">Reports to</span>
        <span class="st-route-stop is-removed">{{ managerName }}</span>
        <i class="bi bi-arrow-right" aria-hidden="true"></i>
        <span class="st-route-stop is-admin">Admin</span>
      </div>
    </div>
  </div>

  @if (staysNote) {
    <div class="remove-note">
      <i class="bi bi-diagram-3" aria-hidden="true"></i>
      <span>{{ staysNote }}</span>
    </div>
  }
</div>

<div class="st-dialog-footer">
  <button type="button" class="btn btn-light ms-auto" (click)="activeModal.dismiss()">Cancel</button>
  <button type="button" class="btn btn-danger d-flex align-items-center gap-2" (click)="activeModal.close(true)">
    <i class="bi bi-person-dash"></i>
    Remove manager
  </button>
</div>
